import { IAidasOrganisation } from 'app/shared/model/ainnotateservice/aidas-organisation.model';
import { IAidasCustomer } from 'app/shared/model/ainnotateservice/aidas-customer.model';
import { IAidasVendor } from 'app/shared/model/ainnotateservice/aidas-vendor.model';
import {IAidasAuthority} from "app/shared/model/ainnotateservice/aidas-authority.model";

export interface IAidasUser {
  id?: number;
  locked?: boolean;
  login?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  activated?: boolean;
  langKey?: string;
  authorities?: any[];
  createdBy?: string;
  createdDate?: Date | null;
  lastModifiedBy?: string;
  lastModifiedDate?: Date | null;
  password?: string;
  aidasOrganisation?: IAidasOrganisation | null;
  aidasCustomer?: IAidasCustomer | null;
  aidasVendor?: IAidasVendor | null;
  aidasAuthorities?: IAidasAuthority[];
}

export const defaultValue: Readonly<IAidasUser> = {
  locked: false,
  login: '',
  firstName: '',
  lastName: '',
  email: '',
  activated: true,
  langKey: 'en',
  aidasAuthorities: [],
  createdBy: '',
  createdDate: null,
  lastModifiedBy: '',
  lastModifiedDate: null,
  password: '',
  aidasOrganisation:  null,
  aidasCustomer:  null,
  aidasVendor:  null,
};
